import actionBridgeMiddleware from './action-bridge-middleware';

export default actionBridgeMiddleware;
